<template>
  <div class="thanks">
    <div class="content">
      <h1 v-if="callInitiated">{{$t('pages.thanks.title-h1')}}</h1>
      <Representative
        class="representative"
        :mep="mep"
        :onFrontpage="false"
        :callInitiated="callInitiated"
        :callButtonIsShown="!callInitiated"
        :callButtonFunction="showPhoneinput" />
      <transition id="call" name="slide-fade">
        <div class="recurring-container phoneinput"
          v-if="phoneinputIsShown && !callInitiated && officeClosed">
          <RecurringDatetimePicker class="recurring-picker" />
          <PhoneInputContainer on-submit="recurring-signup" :button-text="$t('pages.thanks.sign-up-now')" />
        </div>
        <PhoneInput class="phoneinput"
          v-if="phoneinputIsShown && !callInitiated && !officeClosed" />
      </transition>
      <div id="tips">
        <h2>{{ $t('pages.thanks.text-4') }}</h2>
        <ul class="message-container">
          <li class="talking-points">{{$t('pages.thanks.talking-points.tp-1')}}</li>
          <li class="talking-points">{{$t('pages.thanks.talking-points.tp-2')}}</li>
          <li class="talking-points">{{$t('pages.thanks.talking-points.tp-3')}}</li>
          <li class="talking-points">{{$t('pages.thanks.talking-points.tp-4.before-name')}} {{ mep.name }} {{$t('pages.thanks.talking-points.tp-4.after-name')}}</li>
        </ul>
      </div>
      <div class="talking-points-container">
        <div class="col-left">
          <h3>{{$t('pages.thanks.if-positive')}}</h3>
          <ul>
            <li class="talking-points">{{$t('pages.thanks.talking-points.tp-5')}}</li>
          </ul>
        </div>
        <div class="col-right">
          <h3>{{$t('pages.thanks.if-negative')}}</h3>
          <ul>
            <li class="talking-points">{{$t('pages.thanks.talking-points.tp-6')}}</li>
            <li class="talking-points">{{$t('pages.thanks.talking-points.tp-7')}}</li>
            <li class="talking-points">{{$t('pages.thanks.talking-points.tp-8')}}</li>
            <li class="talking-points">{{$t('pages.thanks.talking-points.tp-9')}}</li>
          </ul>
        </div>
      </div>

      <div v-if="!callInitiated">
        <button
          type="submit"
          v-on:click="showPhoneinput"
          class="phone-button">
          {{ $t('components.phoneinput.call-now') }}
          <div class="button_text-small">{{ $t('components.phoneinput.free') }}</div>
        </button>
      </div>

      <div class="recurring-signup" v-if="callInitiated">
        <p>{{$t('pages.thanks.bubble-5')}}</p>
        <p class="call-over">{{$t('pages.thanks.call-over.text')}}</p>
        <router-link class="phone-button" tag="button" to="recurring-signup">{{$t('pages.thanks.call-over.button-text')}}</router-link>
      </div>

      <transition name="fade-all">
        <div class="share-container" v-if="shareboxIsShown">
        <div class="share">
          <p class="text-1">{{$t('share.text-1')}}</p>
          <p class="text-2">{{$t('share.text-2')}}</p>
          <p class="text-3">{{$t('share.text-3')}}</p>
          <div class="share-content">
            <p class="share-text">
              {{$t('share.share-text')}}<br>
              https://pledge2019.eu
            </p>
            <div class="share-buttons">
              <a target="_blank" :href="'https://twitter.com/intent/tweet?text=' + encodeURIComponent( $t('share.share-text') + '\nhttps://pledge2019.eu' )" class="sharebtn twitter">{{$t('share.twitter')}}</a>
              <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://pledge2019.eu' ) + '&quote=' + encodeURIComponent( $t('share.share-text') )" class="sharebtn facebook">{{$t('share.facebook')}}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>


    </div>
  </div>
</template>

<script>
import Representative from '@/components/SectionCalling/Representative.vue'
import PhoneInput from '@/components/SectionCalling/PhoneInput.vue'
import RecurringDatetimePicker from '@/components/RecurringSignup/RecurringDatetimePicker.vue'
import PhoneInputContainer from '@/components/SectionCalling/PhoneInputContainer.vue'

export default {
  name: 'Thanks',
  components: {
    Representative,
    PhoneInput,
    RecurringDatetimePicker,
    PhoneInputContainer,
  },
  data () {
    return {
      phoneinputIsShown: false,
      shareboxIsShown: false
    }
  },
  computed: {
    mep () {
      return this.$root.mep
    },
    callInitiated () {
      return this.$root.callInitiated
    },
    officeClosed () {
      return this.$root.officeClosed
    }
  },
  created () {
    const scrollTimeout = this.callInitiated ? 500 : 0
    this.checkData()
    setTimeout(() => {
      this.$scrollTo('#tips', 1000, { offset: -50 })
    }, scrollTimeout)
    if(this.callInitiated) {
      this.showShare();
    }
  },
  methods: {
    checkData() {
      if (!this.$root.mep.id) {
        this.$router.push({ name: 'landing', hash: '#calling' })
      }
    },
    showPhoneinput() {
      this.phoneinputIsShown = true
      setTimeout(() => {
        document.querySelector('input[type="tel"]').focus()
        this.$scrollTo('#call', {
          offset: -50
        })
      }, 1)
    },
    showShare() {
      setTimeout(() => {
        this.shareboxIsShown = true
      }, 20000); // show sharebox after 20 sec
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

@media screen and (max-width: 768px) {
  .talking-points-container {
    flex-wrap: wrap;

    div {
      flex: 1 0 100% !important;
      margin: 0 0 5px 0 !important;
    }
  }
}

.thanks {
  padding: 1em;
  min-height: 0;
  max-width: 900px;
  margin: 0 auto;

  .content {
    min-height: 100vh;

    h1 {
      background-color: $dark-text-color;
      color: $main-bg;
      margin: 0.3em 0;
      padding: 0.3em;
      text-align: center;
    }

    .representative {
      margin-bottom: 5px;
    }

    .phoneinput {
      border: 4px solid #000;
      box-shadow: 10px 10px rgba(0,0,0,0.2);
      padding: 20px;
      background-color: #fff;
      position: relative;
      margin-bottom: 2vh;

      &:after {
        content: '';
        position: absolute;
        right: 4em;
        top: 0;
        width: 0;
        height: 0;
        border: 1em solid transparent;
        border-bottom-color: #ffffff;
        border-top: 0;
        margin-top: -1em;
        margin-right: -1em;
      }
      &:before {
        content: '';
        position: absolute;
        right: 4em;
        top: 0;
        width: 0;
        height: 0;
        border: calc(1em + 5px) solid transparent;
        border-bottom-color: #000;
        border-top: 0;
        margin-top: calc(-1em - 5px);
        margin-right: calc(-1em - 5px);
      }
    }

    #tips {
      padding: 1em;
      background-color: white;
      margin: 1em 0 5px;
      h2 {
        font-size: 1.2em;
        line-height: 1em;
        margin: 0;
      }
    }
    .talking-points-container {
      display: flex;

      div {
        padding: 1em;
        background-color: white;
        flex: 1;

        h3 {
          background-color: $dark-text-color;
          color: $main-bg;
          margin: -2.4em 0 0;
          text-align: center;
          font-size: 0.8em;
        }
      }
      .col-left {
        margin-right: 2.5px;
      }
      .col-right {
        margin-left: 2.5px;
      }
    }

    .recurring-signup {
      background-color: white;
      border: 5px solid $dark-text-color;
      padding: 1em;
      margin-top: 1em;

      p {
        margin: 0;
      }
      .call-over {
        margin-top: 1em;
      }
    }
  }
}

@keyframes shareanimation {
  0% {
    transform: translateY(-1em);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.share-container {
  margin: 1em 0;
  .text-1,.text-2,.text-3 {
    margin: .2em 0;
  }
  .text-3 {
    font-weight: 700;
  }
  .text-1 {
    animation: .5s ease-out 0s 1 shareanimation normal backwards;
  }
  .text-2 {
    animation: .5s ease-out 2s 1 shareanimation normal backwards;
    animation-fill-mode: backwards;
  }
  .text-3 {
    animation: .5s ease-out 4s 1 shareanimation normal backwards;
  }
  .share-content {
    animation: .5s ease-out 6s 1 shareanimation normal backwards;
    .share-text {
      padding: 1em;
      background: #fff;
      border: 4px solid #000;
      box-shadow: 10px 10px rgba(0, 0, 0, 0.2);
    }
    .share-buttons {
      display: flex;
      justify-content: flex-end;
      .sharebtn {
        background: #000;
        color: $main-bg;
        line-height: 1;
        padding: .5em 1em;
        font-size: 1.2em;
        font-weight: 700;
        text-transform: uppercase;
        display: inline-block;
        text-decoration: none;
        margin-left: 1em;
        transition: all .3s linear;
        &:hover {
          color: #fff;
          background: #333;
        }
      }
    }
  }
}

.fade-all-enter-active, .fade-all-active {
  transition: opacity 1s;
}
.fade-all-enter, .fade-all-leave-to {
  opacity: 0;
}

.phone-button {
  width: 100%;
  box-shadow: 10px 10px rgba(0, 0, 0, 0.2);
}

.slide-fade-enter-active {
  transition: all .3s ease-in-out;
}
.slide-fade-leave-active {
  transition: all .3s ease-in-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(50px);
  opacity: 0;
}
</style>
